import crypto from 'crypto';

const key = 'TmF0aW9uYWxOQmFua09mT21hbjYeKhHt';
const iv = '1234567898766492';

export const AESDecrypt = (msg: string) => {
   try {
      const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
      const decrypted = decipher.update(msg.replace(/ /g, '+'), 'base64', 'utf8');
      return decrypted + decipher.final('utf-8');
   } catch (error) {
      console.log(error);
      return '';
   }
};
export const AESEncrypt = (msg: string) => {
   try {
      const cipher = crypto.createCipheriv('aes-256-cbc', key, iv);
      const encrypted = cipher.update(msg, 'utf8', 'base64');
      return encrypted + cipher.final('base64');
   } catch (error) {
      console.log(error);
      return '';
   }
};
